// Copyright (c) 2017 Deere & Company

import AllClaimsResult from '@deere/cps-it.warranty-model-factory/lib/claim-search-result';
import t from 'tcomb';

const AllClaims = t.list(AllClaimsResult, 'AllClaims');

export const getDefaultState = () => new AllClaims([]);

export default AllClaims;



// WEBPACK FOOTER //
// ./src/claim/all-claims/state/all-claims.js